export default function (): void {
  const form = document.getElementById('dashboard-form') as HTMLFormElement

  const formName = form.getAttribute('name') as string

  document.querySelectorAll('.dca-pagination .dca-pagination__prev').forEach(function (pagePrevEl) {
    pagePrevEl.addEventListener('click', function () {
      ;(document.getElementById(`${formName}_previousPage`) as HTMLInputElement).value = 'previousPage'
      // @ts-expect-error to check if still needed
      document.forms[formName].submit()
    })
  })

  document.querySelectorAll('.dca-pagination .dca-pagination__next').forEach(function (pageNextEl) {
    pageNextEl.addEventListener('click', function () {
      ;(document.getElementById(`${formName}_nextPage`) as HTMLInputElement).value = 'nextPage'
      // @ts-expect-error to check if still needed
      document.forms[formName].submit()
    })
  })

  document
    .querySelectorAll('.dca-pagination .dca-pagination__page-item:not(.dca-pagination__item--active):not(.dca-pagination__item--disabled)')
    .forEach(function (pageEl) {
      pageEl.addEventListener('click', function () {
        ;(document.getElementById(`${formName}_goToPage`) as HTMLInputElement).value = pageEl.getAttribute('data-page') as string
        // @ts-expect-error to check if still needed
        document.forms[formName].submit()
      })
    })
}
